<template>
  <!-- Page Introduction Wrapper -->
  <div class="page-style-a">
    <div class="container">
      <div class="page-intro">
        <h2>Profile</h2>
        <ul class="bread-crumb">
          <li class="has-separator">
            <i class="ion ion-md-home"></i>
            <router-link :to="{name : 'Home'}">Home</router-link>
          </li>
          <li class="is-marked">
            <a href="account.html">Change Password</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- Page Introduction Wrapper /- -->
  <div class="page-account u-s-p-t-80">
    <div class="row justify-content-center">
      <form action="" class="col-lg-5">
        <div class="">
          <label for="user-name-email">Current Password </label>
          <input
            type="text"
            id="user-name-email"
            class="text-field"
            placeholder="Current Password"
            required
          />
        </div>
        <div class="">
          <label for="user-name-email">New Password </label>
          <input
            type="text"
            id="user-name-email"
            class="text-field"
            placeholder="New Password"
            required
          />
        </div>
        <div class="">
          <label for="user-name-email">Confirma Password </label>
          <input
            type="text"
            id="user-name-email"
            class="text-field"
            placeholder="Confirm Password"
            required
          />
        </div>
        <div class="mt-3">
          <button class="button button-primary w-100">Change Password</button>
        </div>
      </form>
    </div>
  </div>
  <Footer />
</template>

<script>
import axios from "axios";
import Footer from "../components/Bottom/Footer.vue";
import Spinner from "../components/Loaders/Spinner.vue";
import Popper from "vue3-popper";
export default {
  components: { Footer, Spinner, Popper },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
</style>
